import { useState } from "react";
import { api } from "../../../../../../../utility/api";
import { descargarReporteExcel } from "../../../helpers/descargarReporteExcel";

export const ResumenConsumoProdApi = () => {
    const [cargando, setCargando] = useState(false);

    const getResumenConsumo = async (params) => {
        try {
            setCargando(true);
            const response = await api.get(
                "reportes_produccion/resumen_consumo",
                params,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const descargarResumenConsumoExcel = async (params) => {
        try {
            setCargando(true);
            await descargarReporteExcel(
                "reportes_produccion/resumen_consumo_excel",
                params,
                "resumen_consumo_produccion.xlsx",
            );
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getResumenConsumo,
        descargarResumenConsumoExcel,

        cargando,
    };
};
